import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-regular-svg-icons';

import {useTheme} from "../../styles/theme/themeContext.jsx";
import { UserAuth } from "../../authentication/AuthContext";
import { LANDING_PATH } from '../../config/accessControl.js';

import LogoIcon from '../../assets/homepage/logo.svg?react'

import './PublicHeader.css';

export const PublicHeader = () => {

    const { user, logOut } = UserAuth();
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();
    const registeredUserId = useSelector(state => state.userDetails.userId);

    const handleSignOut = async () => {
        try {
            await logOut();
            navigate('/home');
        } catch (error) {
            console.log(error);
        }
    };

    const handleLogin = () => {
        navigate('/account?mode=login');
    }

    const handleGetStartedClick = () => {
        navigate('/account?mode=signup');
    };

    const handleLogoClick = () => {
        // Go home and scroll to the top. navigate alone is a no-op when already
        // on /home (and a #section hash may be set). The page scrolls inside the
        // .homepage-body container (not the window), so scroll that to the top.
        navigate('/home');
        requestAnimationFrame(() => {
            const scroller = document.querySelector('.homepage-body');
            (scroller || window).scrollTo({ top: 0, behavior: 'smooth' });
        });
    };

    const handleGoToDashboard = () => {
        // User is authenticated via Firebase but has not completed DB registration yet.
        // Send them to the registration page instead of letting them slip into the dashboard.
        if (!registeredUserId) {
            navigate('/signup');
            return;
        }
        navigate(LANDING_PATH);
    };

    return (
        <nav className="public-header">
            <div className="public-header-logo" onClick={handleLogoClick}>
                <div className="public-header-logo-icon">
                    <LogoIcon />
                </div>
                <div className="public-header-logo-text">
                    <span className="public-header-logo-title">GEOPLAY</span>
                    <span className="public-header-logo-subtitle">Intelligence</span>
                </div>
            </div>
            <div className="public-header-nav">
                <a href="#architecture" className="public-header-nav-link"><span>ARCHITECTURE</span></a>
                <a href="#principles" className="public-header-nav-link"><span>PRINCIPLES</span></a>
                <a href="#workflow" className="public-header-nav-link"><span>WORKFLOW</span></a>
                <a href="#value" className="public-header-nav-link"><span>VALUE</span></a>
            </div>

            <div className="public-header-actions">
                <button
                    onClick={toggleTheme}
                    className="public-header-theme-toggle"
                    aria-label="Toggle Theme"
                >
                    <FontAwesomeIcon icon={theme==='dark' ? faSun : faMoon} />
                </button>
                {user?.accessToken ? (
                    <>
                        <button className="public-header-join-waitlist-btn" onClick={handleSignOut}>Logout</button>
                        <button className="public-header-join-waitlist-btn" onClick={handleGoToDashboard}>Go to Dashboard</button>
                    </>
                ) : (
                    <>
                        {/* Playground button hidden — code preserved in /playground route */}
                        <button className="public-header-join-waitlist-btn" onClick={() => handleLogin()}>SIGN IN</button>
                        <button className="public-header-join-waitlist-btn" onClick={handleGetStartedClick}>SIGN UP FOR FREE</button>
                    </>
                )}
            </div>
        </nav>
    );
};